import React from 'react';
import { Link } from 'react-router-dom';
import categoriesData from '../../data/categories.json';

export default function IndexSectionTeamDarkPattern15() {
    const { categories } = categoriesData;

    return (
        <React.Fragment>
            <>
                <section className="py-24 bg-coolGray-900" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-dark2.svg")', backgroundPosition: 'center'}}>
                    <div className="container px-4 mx-auto">
                        <div className="flex flex-wrap items-center justify-between -mx-4 mb-16">
                            <div className="w-full md:w-auto px-4 mb-8 md:mb-0 flex items-center">
                                <div>
                                    <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">OUR PRODUCTS</span>
                                    <h3 className="mb-4 text-4xl md:text-5xl text-white font-bold tracking-tighter">What We Manufacture</h3>
                                    <p className="text-lg md:text-xl text-coolGray-400 font-medium">At Bagga International, we specialize in manufacturing high-quality, durable, and ergonomically designed tool storage solutions for professionals across industries. Our products are built to last, ensuring efficiency, comfort, and reliability in every task.</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 items-stretch">
                            {categories.map((category) => (
                                <div key={category.id} className="w-full md:w-1/2 lg:w-1/3 px-4 mb-12 flex">
                                    <div className="bg-coolGray-800 rounded-lg shadow-lg p-6 flex flex-col justify-between h-full min-h-[480px] w-full">
                                        <div>
                                            <img className="block mb-8 mx-auto" src={category.image} alt={category.name} />
                                            <h3 className="mb-2 text-3xl md:text-4xl leading-tight text-white font-semibold">{category.name}</h3>
                                            <span className="text-lg font-medium text-green-500 mb-4 block">{category.description}</span>
                                        </div>
                                        <Link
                                            to={`/categories/${category.id}`}
                                            className="inline-block px-5 py-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg shadow transition duration-200 mt-2"
                                            style={{ minWidth: '110px', textAlign: 'center' }}
                                        >
                                            See More
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="w-full flex justify-center mt-8">
                            <Link
                                to="/categories"
                                className="inline-block px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg shadow transition duration-200"
                                style={{ minWidth: '120px', textAlign: 'center' }}
                            >
                                See All
                            </Link>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}
